module.exports = __webpack_public_path__ + "static/img/no-item@2x.d304c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/queshengye/no-item@2x.png
// module id = wlWg
// module chunks = 17